<template>
  <div class="orderArea">
    <div v-for="button in buttonsData" :key="button.id">
      <button
        class="orderButton"
        @click="orderClickHandler(button.id)"
        v-bind:class="{ selected: selectedHandler(button.id) }"
      >
        {{ button.text }}
      </button>
    </div>
  </div>
</template>

<script>
import { ORDER } from "../js/Constants.js";
import EventBus from "../EventBus.js";
import {
  ORDER_CLICK_EVENT,
  REFRESH_TABLE_CONTROLS_ORDER_EVENT,
} from "../js/event.js";

export default {
  name: "table-order-component",
  props: {
    buttonsData: { type: Array, required: true },
  },
  data() {
    return {
      selectedId: "newest",
      isButtonIcon: false,
    };
  },
  methods: {
    orderClickHandler(id) {
      this.$emit(ORDER_CLICK_EVENT, id);
      this.selectedId = id;
    },
    selectedHandler(id) {
      return id === this.selectedId;
    },
  },
  created() {
    this.isButtonIcon = this.buttonsData.icon;
  },
  mounted() {
    EventBus.$on(
      REFRESH_TABLE_CONTROLS_ORDER_EVENT,
      () => (this.selectedId = ORDER.NEWEST)
    );
  },
  destroyed() {
    EventBus.$off(REFRESH_TABLE_CONTROLS_ORDER_EVENT);
  },
};
</script>
<style lang="scss" scoped>
@import "../styles/hpConstant.scss";
@import "../styles/hpCustom.scss";
@import "../styles/hpMixin.scss";

.orderArea {
  @include boxSizingBorderBox;
  display: flex;
  flex-direction: row;
  height: 100%;

  div {
    .orderButton {
      border-style: none;
      padding: 7px 20px;
      font-size: 16px;
      background-color: $hpLightGray;
      cursor: pointer;
      height: 50px;
      color: $hpBlack;

      .icons {
        position: relative;
        top: 2px;
        height: 16px;
        // margin-right: 200px;
      }
    }
    .orderButton:hover {
      color: $hpWhite;
      background-color: $hpPrimary;
    }
    .selected {
      color: $hpWhite;
      background-color: $hpPrimary;
    }

    @media only screen and (max-width: 576px) {
      .orderButton {
        padding: 7px 5px;
      }
    }
  }
}
</style>
